import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Divider from '../components/Divider'
import { createPaymentFromPreBookingId, getPreBookingList } from '../hooks/preBookings'

export default function PreBookingList() {
    const [preBookingList, setPreBookingList] = useState([])
    const navigate = useNavigate()

    const getPreBookings = async () => {
        let preBookings = await getPreBookingList()
        console.log(preBookings.data)
        setPreBookingList(preBookings.data)
    }

    const createPayment = async (preBookingId, orderNumber) => {
        if (orderNumber && orderNumber.length > 0) {
            navigate(`/payment/${orderNumber}?mode=preBooking`)
        } else {
            try {
                const booking = await createPaymentFromPreBookingId(preBookingId)
                navigate(`/payment/${booking.data.orderNumber}`)
            } catch (error) {
                alert(`[${error.response.status}]: การจองล้มเหลว`)
            }
        }
    }

    const renderStatus = (preBooking) => {
        if (preBooking.orderNumber === "")
            return "รอการชำระเงิน"
        else {
            if (preBooking.booking.status === 0) {
                return "รอการชำระเงิน"
            } else if (preBooking.booking.status === 1) {
                return "การจองเสร็จสมบูรณ์"
            } else if (preBooking.booking.status === 2) {
                return "ยกเลิก"
            } else if (preBooking.booking.status === 3) {
                return "ยกเลิกโดย Admin"
            } else if (preBooking.booking.status === 4) {
                return "ไม่ได้ชำระเงินภายในเวลาที่กำหนด"
            }
        }
    }

    useEffect(() => {
        getPreBookings()
    }, [])

    return (
        <div>
            <br />
            <h1 align="center">Pre Bookings</h1>
            <Divider />
            <div className='container'>
                <div className='row'>
                    {
                        preBookingList.map((preBooking, i) => {
                            return (<div className='col-xs-12 col-sm-12 col-md-4' key={i}>
                                <div className='card card-body m-2'>
                                    <h5>{preBooking.rawData["งาน"]}</h5>
                                    <hr />
                                    <p>วันที่: {preBooking.rawData["วันที่จอง"]}</p>
                                    <p>ประเภท: {preBooking.rawData["ประเภทการเดินทาง"]}</p>
                                    <p>รอบ: {preBooking.rawData["รอบการเดินทาง"]}</p>
                                    <p>สาย: {preBooking.rawData["เส้นทาง"]}</p>
                                    <p>จำนวนที่นั่ง: {preBooking.rawData["จำนวนที่นั่ง"]}</p>
                                    <p>เบอร์โทร: {preBooking.rawData["เบอร์โทรศัพท์"]}</p>
                                    <p>สถานะ: {renderStatus(preBooking)}</p>
                                    <br />
                                    {
                                        (preBooking.status === 0 || preBooking.booking.status === 0) && <button className='btn btn-primary' onClick={() => createPayment(preBooking._id, preBooking.orderNumber)}>ชำระเงิน</button>
                                    }
                                </div>
                            </div>)
                        })
                    }
                </div>
            </div>
            <br /><br /><br />
        </div>
    )
}
